import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    Chat: {
      subtitle:
        'Average response time guaranteed from Monday to Friday from 9am to 12pm and 2pm to 5pm. On weekends, we respond to your requests within a day.',
      tag: '1 h',
      title: 'Contact us by chat',
    },
    title: 'I have an emergency',
  },
  fr: {
    Chat: {
      subtitle:
        'Délai de réponse moyen garanti du lundi au vendredi de 9h à 12h et 14h à 17h. Le week-end, nous répondons à vos demandes dans la journée.',
      tag: '1 h',
      title: 'Nous contacter par chat',
    },
    title: 'J’ai une urgence',
  },
} as const);

export default locales;
